import React, { useRef } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import { FEATURES } from '../data';
import './FeaturesStrip.css';

const FeatureIcon = ({ type }) => {
  switch (type) {
    case 'wholesale':
      return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <path d="M6 10h24M6 18h24M6 26h16" stroke="#C9973A" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="28" cy="26" r="5" stroke="#C9973A" strokeWidth="1.5"/>
          <path d="M26 26l1.5 1.5L30 24" stroke="#C9973A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'exchange':
      return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="14" stroke="#C9973A" strokeWidth="1.5"/>
          <path d="M12 16l3-3 3 3M24 20l-3 3-3-3" stroke="#C9973A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15 13v7M21 23v-7" stroke="#C9973A" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      );
    case 'buyback':
      return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="14" stroke="#C9973A" strokeWidth="1.5"/>
          <path d="M12 18l4 4 8-8" stroke="#C9973A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'purity':
      return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <path d="M18 4l2.5 7.5H28l-6.5 4.5 2.5 7.5L18 19l-6 4.5 2.5-7.5L8 11.5h7.5L18 4z" stroke="#C9973A" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
          <path d="M14 28h8M12 31h12" stroke="#C9973A" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      );
    default:
      return null;
  }
};

export default function FeaturesStrip() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  return (
    <section className="features-strip" ref={ref} id="features">
      <div className="features-strip__grid">
        {FEATURES.map((feature, i) => (
          <div
            key={feature.id}
            className={`feature-card${visible ? ' visible' : ''}`}
            style={{ transitionDelay: `${i * 0.12}s` }}
          >
            {/* Vertical divider (not on last) */}
            {i < FEATURES.length - 1 && <span className="feature-card__divider" />}

            <div className="feature-card__icon">
              <FeatureIcon type={feature.icon} />
            </div>
            <div className="feature-card__body">
              <h3 className="feature-card__title">{feature.title}</h3>
              <p className="feature-card__desc">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
